import { createActionTypes } from "@helpers/redux-helpers";

export const getCreateSubscriptionPostsActionTypes = createActionTypes(
  "createSubscription/posts/get",
);

export const getMoreCreateSubscriptionPostsActionTypes = createActionTypes(
  "createSubscription/posts/getMore",
);

export const attachPostsActionTypes = createActionTypes(
  "createSubscription/posts/attach",
);
